import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ListIcon } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { formatDate } from 'src/utils/misc';

interface EFScenarioIdentifiedProps {
  showDate?: string;
  assessment: {
    id: string;
    name: string;
  };
  scenario: {
    id: string;
    name: string;
  };
  truncate?: boolean;
}

export const EFScenarioIdentified: React.FC<EFScenarioIdentifiedProps> = ({
  showDate,
  assessment,
  scenario,
  truncate,
}) => {
  return (
    <Base
      iconComponent={<ListIcon />}
      constentComponent={
        <Text nowrap={truncate}>
          {showDate && <Text className="sdate">{formatDate(showDate)}</Text>} Risk Scenario{' '}
          <Link
            to={`/risk-assessments/${assessment.id}/scenario/${scenario.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Scenario'],
                  params: {
                    id: scenario.id,
                  },
                },
                tags: ['TIMELINE', 'SCENARIO'],
              })
            }
          >
            <TextLink>{scenario.name}</TextLink>
          </Link>{' '}
          identified.
        </Text>
      }
    />
  );
};
